import { createContext, useContext, useEffect, useState } from "react";
import { offlineDB } from "../offline/db";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ================= HYDRATE ON APP LOAD ================= */
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedBranch = localStorage.getItem("branch");
    const token = localStorage.getItem("token");

    if (storedUser && token) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        localStorage.clear();
      }
    }

    if (storedBranch) {
      try {
        setBranch(JSON.parse(storedBranch));
      } catch {
        localStorage.removeItem("branch");
      }
    }

    setLoading(false);
  }, []);

  /* ================= LOGIN ================= */
  const login = async (data) => {
    /**
     * Expected data shape:
     * {
     *   token,
     *   user,
     *   branch
     * }
     */

    setUser(data.user);
    setBranch(data.branch);

    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("branch", JSON.stringify(data.branch));

    // 🔥 SAVE BRANCH TO OFFLINE DB (CRITICAL)
    if (data.branch?.branch_id) {
    offlineDB.branches.put(data.branch).catch(console.error);
  }
  };

  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.clear();
    setUser(null);
    setBranch(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        branch,     // ✅ expose branch
        login,
        logout,
        loading
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
